import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';

import { ThemeProvider } from './components/theme-provider';
import { Toaster } from './components/ui/sonner';
// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance.
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  // biome-ignore lint/style/useConsistentTypeDefinitions: spec requires interface
  interface Register {
    router: typeof router;
  }
}

// Render the app
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ThemeProvider defaultTheme="light">
        <Toaster />
        <RouterProvider router={router} />
      </ThemeProvider>
    </StrictMode>,
  );
}
